import { ProductSwitchStatusResponse } from '@eneco/dc-be/client';

interface canUserSwitchProductTypes {
  isCurrentAccountReader: boolean;
  isActiveProduct: boolean;
  hasProductSwitchOptions: boolean;
  isSocialTariff: boolean;
  productSwitchStatus: ProductSwitchStatusResponse | undefined;
}

export const canUserSwitchProduct = ({
  isCurrentAccountReader,
  isActiveProduct,
  hasProductSwitchOptions,
  isSocialTariff,
  productSwitchStatus,
}: canUserSwitchProductTypes): boolean => {
  const isPendingProductSwitch =
    productSwitchStatus === 'TransitioningToProductSwitch' || productSwitchStatus === 'PendingProductSwitch';
  return (
    !isCurrentAccountReader && isActiveProduct && hasProductSwitchOptions && !isSocialTariff && !isPendingProductSwitch
  );
};
